<template>
<div class="contact-list">

    <vue-headful
      title="Designbox - Manage Users"
      description="Designbox"
    />

    <div class="container">
        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'manage-users'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <hr>
                <div class="content">
                    <h2>{{ $t("overview-contacts") }}</h2>
                    <p>{{ $t("contacts-overview-details") }}</p>
                    <b-table :data="filteredContacts"
                        paginated
                        per-page="25"
                        detailed
                        detail-key="id"
                        :opened-detailed="actLinksAvailable"
                        :show-detail-icon="false"
                                >
                        <template slot-scope="props" slot="header">
                            <div v-if="props.column.field == 'email'" @click.stop>
                                {{ props.column.label }}<b-input size="is-small" v-model="filter_email" placeholder="e-mail"></b-input>
                            </div>
                            <div v-else>
                                {{ props.column.label }}
                            </div>
                        </template>
                        <b-table-column field="email" :label="$t ('email')" sortable :searchable="true">
                            <template v-slot="props">
                                {{ props.row.email }}
                            </template>
                        </b-table-column>
                        <b-table-column field="first_name" :label="$t ('name')" sortable>
                            <template v-slot="props">
                                {{ props.row.first_name }} {{ props.row.middle_name }} {{ props.row.last_name }}
                            </template>
                        </b-table-column>
                        <b-table-column field="is_active" :label="$t ('active')" sortable>
                            <template v-slot="props">
                                <b-checkbox v-model="props.row.is_active" disabled></b-checkbox>
                            </template>
                        </b-table-column>
                        <b-table-column field="company" :label="$t ('company')" sortable>
                            <template v-slot="props">
                                {{ props.row.company }}
                            </template>
                        </b-table-column>
                        <b-table-column field="delete"
                        >
                            <template v-slot="props">
                                <b-button type="is-danger"
                                    @click="deleteContact (props.row.id)"
                                    >{{ $t ('delete') }}</b-button>
                            </template>
                        </b-table-column>
                        <b-table-column field="activationLink"
                        >
                            <template v-slot="props">
                                <b-button type="is-link"
                                    @click="getActivationLink (props.row)"
                                >{{ $t ('activation-link') }}</b-button>
                            </template>
                        </b-table-column>
                        <template slot="detail" slot-scope="props">
                            Activation link: {{ props.row.actLink }}
                        </template>
                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                            icon="sad-tear"
                                            size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>{{ $t ("no-users") }}</p>
                                </div>
                            </section>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import MenuVert         from '@/components/MenuVert'
import { mapGetters }   from 'vuex'
import axios from "axios";

export default {
    name:'ManageUsers',
    computed: {...mapGetters(["contactList", "getUserToken"]),
        filteredContacts () {
            return this.contactList.filter (c => c.email.includes (this.filter_email))
        }
    },
    data: function () {
        return {
            active: false,
            filter_email: "",
            actLinksAvailable: []
        }
    },
    components: {MenuVert},
    methods: {
        editContact(cid) {
            this.$router.push ({name : 'contact-edit', params: {coid : cid}})

        },
        deleteContact(cid) {
            this.$store.dispatch ("deleteContact", {self: this, cid: cid})
        },
        getActivationLink (row) {
            axios.get (`/vue/contact/${row.id}/activation-link/`,
                { headers: { Authorization: "Token " + this.getUserToken } }
            ).then (response => {
                if (response.data.status) {
                    row.actLink = response.data.data.act_link
                    this.actLinksAvailable.push (row.id)
                }
            })
        }
    },
    mounted () {
        this.$store.dispatch ( "fetchContactList",
        { self: this, active: this.active})
    }
}
</script>

<style>
.contact-list{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
